import { FormControlLabel, FormHelperText, Checkbox, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

type CheckboxProps = {
    onClick: (checked: boolean) => void
    name: string
    label: string
    checked?: boolean
    disabled?: boolean
    required?: boolean
    labelPlacement?: 'top' | 'bottom' | 'start' | 'end'
    color?: 'primary' | 'secondary'
    overrideClass?: {}
    classNameLabel?: string
}

const CheckboxControl = (props: CheckboxProps) => {
    const {
        onClick,
        name,
        label,
        checked,
        disabled,
        required,
        labelPlacement = 'end',
        color = 'primary',
        overrideClass,
        classNameLabel,
    } = props
    const { t } = useTranslation()

    return (
        <div>
            <FormControlLabel
                control={
                    <Checkbox
                        name={name}
                        checked={checked}
                        onChange={(event: any) => {
                            onClick(event.target.checked)
                        }}
                        color={color}
                        classes={overrideClass}
                    />
                }
                label={<Typography className={classNameLabel}>{label}</Typography>}
                labelPlacement={labelPlacement}
                disabled={disabled}
            />
            <FormHelperText>
                <label style={{ color: '#d32f2f' }}>
                    {!disabled ? (required ? t('LABEL.SELECT_REQUIRED') : '') : ''}
                </label>
            </FormHelperText>
        </div>
    )
}

export default CheckboxControl
